import React from 'react';
import { Divider } from 'antd';
import { marginOnPageButton } from '../../constants/gridConfig';

// Trait vertical séparant deux groupes de contrôles dans une barre d'outils.
// Extrait de Navbar : la barre flottante du container en a besoin, et importer
// Navbar depuis Container fermait un cycle de modules
// (Navbar -> RightProperties -> ConfigurationModal -> pageTab -> Container).
export const Separator = ({ hidden, color = 'white' }) => {
  return (
    <Divider
      type="vertical"

      style={{
        display: hidden ? 'none' : 'block',
        top: 0,
        height: '36px',
        margin: `0px ${3 * marginOnPageButton}px 0px ${2 * marginOnPageButton}px`,
        borderLeft: `2px solid ${color}`,
      }}
    />
  );
};
